// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import App from './App'
import router from './router'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/main.css'
import 'vuejs-noty/dist/vuejs-noty.css'
import * as store_token from '@/services/store_token.js'
import store from '@/store/store.js'
import VueNoty from 'vuejs-noty'
import Vuelidate from 'vuelidate'
import VueApexCharts from 'vue-apexcharts'

Vue.config.productionTip = false
Vue.use(Vuelidate)

 
Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(VueNoty)
new Vue({
  el: '#app',
  beforeCreate () {
    //console.log(process.env)
    Vue.prototype.$http = axios
    axios.defaults.headers.common['Authorization'] = "Bearer  " + store_token.getlocalToken('auth_token')
    axios.defaults.xsrfHeaderName = 'X-CSRFToken'
    axios.defaults.xsrfCookieName = 'csrftoken' 
  },
  store,
  store_token,
  router,
  components: { App },
  template: '<App/>'
})

const auth_token = store_token.getlocalToken('auth_token')
if (auth_token) {
  store_token.setlocalToken('auth_token',auth_token)
}



// WEBPACK FOOTER //
// ./src/main.js